// Loads where an application can be forwarded / returned to, for a forward
// setup from applicationListConfig.js or detailConfig.js.
//
// Resolves to [{ name, label, role, userId, person }]:
//   name   full option name, e.g. "Superintendent · Kottayam Division"
//   label  short destination name for buttons, e.g. "Superintendent"
//   userId id sent to /forward/ (the backend turns it into that user's seat)
import axios from "axios";
import { forwardTargets, seatLabel, getCwwConfig } from "@/components/Common/cwwConfig";

const CWW_LIST_URLS = {
  adminclerk: "/adminclerk/forward/list",
  adminsuperint: "/adminministerial/forward/list",
  dcf: "/dcf/forward/list",
};

export function loadForwardTargets(setup, appid) {
  return axios({
    method: "post",
    url: setup.cwwRole ? CWW_LIST_URLS[setup.cwwRole] : setup.listUrl,
    headers: {
      token: localStorage.getItem("token"),
    },
    data: { appid },
  }).then((response) => {
    const data = response.data || {};
    let users = setup.cwwRole
      ? forwardTargets(setup.cwwRole, data)
      : (setup.targets || [])
          .filter((t) => data[t.key])
          .map((t) => ({
            // A seat (role + office) unless the target is a person (the applicant).
            name: t.person ? `${t.label} · ${data[t.key].username}` : seatLabel(t.label, data[t.key]),
            label: t.label,
            role: t.role,
            userId: data[t.key]._id,
            person: !!t.person,
            revert: !!t.revert,
          }));
    if (setup.includeApplicant && data.applicant) {
      users = users.concat([
        {
          name: `Applicant · ${data.applicant.username}`,
          label: "Applicant",
          role: "User",
          userId: data.applicant._id,
          person: true,
          revert: true,
        },
      ]);
    }
    return users;
  });
}

// Button text for one destination, e.g. "Forward to DFO" / "Revert to DFO Clerk".
// A destination further back in the chain (the clerk below the MH, the applicant)
// is a revert, not a forward.
export function targetActionLabel(setup, target) {
  const verb = target.revert ? "Revert" : setup.buttonLabel || "Forward";
  return `${verb} to ${target.label}`;
}

// True when the setup can send the application back as well as forward.
export function setupHasRevert(setup) {
  if (!setup) return false;
  if (setup.includeApplicant) return true;
  if (setup.cwwRole) return (getCwwConfig(setup.cwwRole).targets || []).some((t) => t.revert);
  return (setup.targets || []).some((t) => t.revert);
}
